import { useQuery } from '@tanstack/react-query';
import { getProviderCandidates } from '../../services';

export const providerCandidateKeys = {
    all: ['providerCandidates'] as const,
    byAlert: (alertId: number) =>
        [...providerCandidateKeys.all, 'alert', alertId] as const,
};

/**
 * Proximity-ranked provider organizations for an active alert.
 * The backend is the source of truth for ordering, coverage, and exclusion
 * of organizations already holding a live invitation — no client-side
 * filtering is applied on top of this.
 */
export function useProviderCandidates(alertId: number | undefined) {
    return useQuery({
        queryKey: providerCandidateKeys.byAlert(alertId ?? 0),
        queryFn: () => getProviderCandidates({ alert_id: alertId as number }),
        enabled: !!alertId,
    });
}
